module.exports = __WEBPACK_EXTERNAL_MODULE_103__;


//////////////////
// WEBPACK FOOTER
// external "aws-sdk/clients/lexruntime"
// module id = 103
// module chunks = 0